import { useState, useCallback, ReactNode } from 'react'

export interface Notification {
  id: string
  type: 'success' | 'info' | 'failure'
  message: ReactNode
}

export interface UseNotificationsManager {
  notifications: Notification[]
  setNotifications(notifications: Notification[]): void
  setNotification(notification: Notification): void
  clearNotifications(): void
  clearNotification(notificationId: string): void
}

interface NotificationsManagerOptions {
  initialNotifications?: Notification[]
}

const useNotificationsManager = ({
  initialNotifications = [],
}: NotificationsManagerOptions = {}): UseNotificationsManager => {
  const [notifications, setNotifications] =
    useState<Notification[]>(initialNotifications)

  const setNotification = useCallback((notification) => {
    setNotifications((notifications) => {
      if (notifications.some((n) => n.id === notification.id)) {
        return notifications
      }

      return [...notifications, notification]
    })
  }, [])

  const clearNotifications = useCallback(() => setNotifications([]), [])

  const clearNotification = useCallback(
    (id) =>
      setNotifications((notifications) =>
        notifications.filter((notification) => notification.id !== id)
      ),
    []
  )

  return {
    notifications,
    setNotifications,
    setNotification,
    clearNotifications,
    clearNotification,
  }
}

export default useNotificationsManager
